import React from 'react';
import { useTranslation } from 'react-i18next';
import PageTransition from '../components/common/PageTransition';
import SEOHead from '../components/common/SEOHead';
import SectionHeader from '../components/common/SectionHeader';

const Legal: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageTransition>
      <SEOHead title={t('legal.legalPage.title')} />
      <div className="space-y-12">
        <SectionHeader
          title={t('legal.legalPage.title')}
          description={t('legal.legalPage.description')}
          iconName="FileText"
          badge={t('legal.legalPage.badge')}
        />
        <div className="art-card p-6 md:p-8 rounded-2xl border-black/5 dark:border-white/10 space-y-6 text-slate-700 dark:text-slate-300">
          <section>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">{t('legal.legalPage.publisher.title')}</h3>
            <p>{t('legal.legalPage.publisher.p1')}</p>
            <p>{t('legal.legalPage.publisher.p2')}</p>
          </section>
          
          <section>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">{t('legal.legalPage.hosting.title')}</h3>
            <p>{t('legal.legalPage.hosting.p1')}</p>
          </section>
          
          <section>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">{t('legal.legalPage.ip.title')}</h3>
            <p>
              {t('legal.legalPage.ip.p1')}
            </p>
          </section>
        </div>
      </div>
    </PageTransition>
  );
};

export default Legal;
